export const API_URL = process.env.REACT_APP_BASE_URL ?? 'https://gro-d-gup-app.azurewebsites.net/';
export const YOUTUBE_EMBED = '//www.youtube.com/';
